import React from "react";
import { Box, Grid, Stack } from "@mui/material";
import { useVenderEquipoOT } from "./VenderEquipoOT";
import { useVenderAccesoriosOT } from "./VenderAccesoriosOT";

// Combina VenderEquipoOT + VenderAccesoriosOT en un único Grid de 2 columnas para que
// "Accesorios Vendidos" quede apilado justo debajo de "Equipos Vendidos en esta OT" en
// la columna derecha, sin depender de la altura de las tablas de la izquierda (cada
// columna es su propia Stack, no una fila de Grid compartida entre ambos componentes).
const VenderEquipoYAccesoriosOT = ({
  cod_ot,
  cod_cliente,
  cod_servicio_cliente,
  servicio,
  esTKR,
  esAVL,
  onEnviado,
  onVendidosCambiados,
}) => {
  const equipo = useVenderEquipoOT({
    cod_ot,
    cod_cliente,
    cod_servicio_cliente,
    servicio,
    esTKR,
    esAVL,
    onEnviado,
    onVendidosCambiados,
  });
  const accesorios = useVenderAccesoriosOT({ cod_ot, cod_cliente, servicio });

  return (
    <Box sx={{ mt: 1 }}>
      <Grid container spacing={1.5}>
        <Grid size={{ xs: 12, md: 8 }}>
          <Stack spacing={1.5}>
            {equipo.left}
            {accesorios.left}
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Stack spacing={1.5}>
            {equipo.right}
            {accesorios.right}
          </Stack>
        </Grid>
      </Grid>
      {equipo.dialogs}
      {accesorios.dialogs}
    </Box>
  );
};

export default VenderEquipoYAccesoriosOT;
